import { ProductConditionListCheckModel } from "../condition-lists/product-condition-list-check.model";
import { ProductModel } from "../product/product.model";

export class ConditionListsAgreementModel {
    public constructor(
        public product: ProductModel,
        public conditions: ProductConditionListCheckModel,
        public onConfirm: () => void,
        public onReject: () => void
    ) {
    }
}
